import { IMessage, IUserData } from '../entities';
import { fetchUserFromServer, fetchUsersFromServer } from './utils/fetchFromServer';
import { toggleUserStatus } from './utils/updateOnServer';
import { simpleClient } from 'services/apiGatewayClient';

export const client = simpleClient<IUserData>();

export async function fetchAllUsers(): Promise<IUserData[]> {
  const url = '/users';
  return await fetchUsersFromServer(url);
}

export async function fetchUserById(id: string): Promise<IUserData> {
  const url = `/users/${id}`;
  return await fetchUserFromServer(url);
}

export async function toggleUserStatusById(id: string, enabled: boolean): Promise<IMessage> {
  const url = `/users/${id}/status`;
  return await toggleUserStatus(url, enabled);
}

export async function postUser(user: IUserData) {
  return await client.post(`/users`, user);
}

export async function putUser(user: IUserData) {
  return await client.put(`/users/${user.sub}`, user);
}
